import { request } from '@/utils'

export default {
  upload({ formData }) {
    return request({
      method: 'POST',
      path: '/recognize',
      body: formData,
      isUpload: true,
      headers: {}
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/audio.js